import "./BulkProgress.css";

import { BulkProgressProps, progressBarSx } from "./BulkUtils";
import CancelIcon from "@mui/icons-material/Cancel";
import SandClockUrl from "../../assets/gif/sandClock.gif";
import { cancelIconStyles } from "./ManageSecondaryOrderUtils";
import { ReactComponent as DisclaimerIcon } from "../../assets/image/svg/disclaimer.svg";
import LinearProgress from "@mui/material/LinearProgress";
import { useEffect, useState } from "react";
import RenderSvg from "../../components/renderSvg/RenderSvg";

const BulkProgress: React.FC<BulkProgressProps> = ({
  bulkStatusMap,
  type = "invoice",
  showProgress,
  handleHideProgress,
  isBulkRejection
}) => {
  const [total, setTotal] = useState(0);
  const [failed, setFailed] = useState(0);
  const [settled, setSettled] = useState(0);
  const [rejected, setRejected] = useState(0);
  const [progressPercentage, setProgressPercentage] = useState(0);

  const isInvoiceType = type === "invoice" ? true : false;

  useEffect(() => {
    const total: number =
      (bulkStatusMap?.failed?.length ?? 0) +
      (bulkStatusMap?.confirmed?.length ?? 0) +
      (bulkStatusMap?.rejected?.length ?? 0) +
      (bulkStatusMap?.invoiced?.length ?? 0) +
      (bulkStatusMap?.inProgress?.length ?? 0) + (bulkStatusMap?.partiallyConfirmed?.length ?? 0) + 
      (bulkStatusMap?.partiallyInvoiced?.length ?? 0);
      

    const failed = bulkStatusMap?.failed?.length ?? 0;

    const settled = total - bulkStatusMap?.inProgress?.length;

    const rejected = bulkStatusMap?.rejected?.length

    const progressPercentage = (settled / (total || 1)) * 100;

    setTotal(total);
    setFailed(failed);
    setSettled(settled);
    setRejected(rejected);
    setProgressPercentage(progressPercentage);

    return () => {
        setTotal(0);
        setFailed(0);
        setSettled(0);
        setProgressPercentage(0);
    }

  }, [bulkStatusMap]);


  const { progress, fail } = showProgress || {};

  return (
    <div className="BulkInvoiceProgress_container">
      <div
        className={`BulkInvoiceProgress_completionProgress ${
          !progress && `BulkInvoiceProgress_hide`
        }`}
      >
        <img src={SandClockUrl} />
        <div className="BulkInvoiceProgress_progressCountContainer">
    
          {
            isBulkRejection ? 
            <>
            <span>
              {`Bulk Rejection ${progressPercentage === 100 ? `completed` : `in progress`}`}{" "}
              <CancelIcon
                style={cancelIconStyles}
                onClick={() => handleHideProgress("progress")}
              />
            </span>
            <div className="BulkInvoiceProgress_progressCount">
              <div className="BulkInvoiceProgress_qtyAndTime">
                <p>
                  <RenderSvg name="CompletedSvg" />{`${rejected}/${total}`} <span>{"Invoices & Orders rejected"}</span>
                </p>
                <p className={`${!fail && `BulkInvoiceProgress_hide`} BulkInvoiceProgress_failedQty`}>
                  <DisclaimerIcon />
                  {`${failed}/${total}`} <span>{"Invoices & Orders failed"} </span> 
                </p>
                <></>
              </div>
              <LinearProgress
                variant="determinate"
                value={progressPercentage}
                sx={progressBarSx}
              />
            </div>
            </>
            :
            <>
          <span>
            {`Bulk ${isInvoiceType ? "invoicing": "confirming"} ${progressPercentage === 100 ? `completed` : `in progress`}`}{" "}
            <CancelIcon
              style={cancelIconStyles}
              onClick={() => handleHideProgress("progress")}
            />
          </span>
          <div className="BulkInvoiceProgress_progressCount">
            <div className="BulkInvoiceProgress_qtyAndTime">
              <p>
                <RenderSvg name="CompletedSvg" />{`${settled -  failed}/${total}`} <span>{isInvoiceType ? "Invoices Generated" : "Orders Confirmed"}</span>
              </p>
              <p className={`${!fail && `BulkInvoiceProgress_hide`} BulkInvoiceProgress_failedQty`}>
                <DisclaimerIcon />
                {`${failed}/${total}`} <span>{isInvoiceType ? "Invoices" : "Confirmation"} Failed</span> 
              </p>
              <></>
            </div>
            <LinearProgress
              variant="determinate"
              value={progressPercentage}
              sx={progressBarSx}
            />
          </div>
            </>
          }
        </div>
        <></>
      </div>
      </div>
    );
  };

export default BulkProgress;
